// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".booking-card-overview .note .panel[data-v-61a791b8] {\n  margin-bottom: 0;\n  max-height: 115px;\n  overflow-y: scroll;\n}\n", ""]);
// Exports
module.exports = exports;
